export default __webpack_public_path__ + "static/media/volcano.bc307268.svg";